import React, { useState } from "react";
import {
  Card,
  // CardHeader,
  CardInfo,
  // ChipsCard,
  // ChipsCardClean,
  IconBox,
  InfoBox,
  // PLineHeigth2,
  PLineHeigth4,
  // Show7d,
} from "./styled-datafetcher";

import { FlexBox } from "../../styles/global";
import { IoIosPeople } from "react-icons/io";
import { FaClock } from "react-icons/fa";
import { useDataContext } from "../../context/DataContext";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { Button, Tooltip } from "@mui/material";
import strings from "constants/strings";
import InfoIcon from "@mui/icons-material/Info";
// import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import UndoIcon from "@mui/icons-material/Undo";

interface QuadroProps {
  hospital: any;
  item: any;
  openModal: (hospital: string, especialidade: string) => void;
  getMetricas: (
    hospital: any,
    metrica: string,
    especialidade: any,
    ultimaSemana?: boolean
  ) => any;
}

const Quadro: React.FC<QuadroProps> = ({
  hospital,
  item,
  openModal,
  getMetricas,
}) => {
  const {
    tempoMedio7dias,
    tempoMedio24horas,
    selectedEspecialidades,
    metricasEspecialidades,
    isSmallScreen,
  } = useDataContext();
  // const [alertaAmarelo, setAlertaAmarelo] = useState(false);
  // const [alertaVermelho, setAlertaVermelho] = useState(false);
  const tempoMedioEspera = getMetricas(
    hospital,
    "tempo_atendimento",
    item,
    true
  );

  const slotProps = (color: string, fontColor: string) => ({
    popper: {
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, -8],
          },
        },
      ],
    },
    tooltip: {
      style: {
        backgroundColor: color,
        color: fontColor,
      },
    },
    arrow: {
      style: {
        color: color,
      },
    },
  });

  const riscoColorMap = [
    { color: "#DE1E1F", risco: "vermelho", fontColor: "#fff" },
    { color: "#E96F19", risco: "laranja", fontColor: "#fff" },
    { color: "#ffce24", risco: "amarelo", fontColor: "#000" },
    { color: "#077d04", risco: "verde", fontColor: "#fff" },
    { color: "#007bff", risco: "azul", fontColor: "#fff" },
  ];

  function getMetricasRisco(
    risco: string,
    hospital: any,
    tipo: string,
    especialidade: any,
    dados: any
  ) {
    const current = especialidade || selectedEspecialidades;
    let valor, resultado;
    if (tipo === "risco") {
      valor = dados[hospital]?.[current];
      resultado = valor?.reduce((acc: number, item: any) => {
        return acc + (item[`${tipo}_${risco}`] || 0);
      }, 0);
    } else {
      // valor = dados[hospital]?.[current];

      const semAcento = (str: string) =>
        str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();

      const chave = Object.keys(dados[hospital] || {}).find((k) =>
        semAcento(k).endsWith(semAcento(current))
      );

      const valor = chave ? dados[hospital]?.[chave] : undefined;
      if (valor?.length === 1) {
        resultado = valor?.[0]?.[`${tipo}_${risco}`];
      } else if (valor?.length === 2) {
        if (
          valor?.[0]?.pacientes_aguardando_atendimento === 0 &&
          valor?.[1]?.pacientes_aguardando_atendimento === 0
        ) {
          resultado = "!";
        } else if (valor?.[0]?.pacientes_aguardando_atendimento !== 0) {
          resultado = valor?.[0]?.[`${tipo}_${risco}`];
        } else {
          resultado = valor?.[1]?.[`${tipo}_${risco}`];
        }
      } else {
        resultado = "?";
      }
    }

    return resultado;
  }

  // function CustomTooltip(props: TooltipProps) {
  //   return (
  //     <Tooltip
  //       arrow
  //       slotProps={{
  //         popper: {
  //           modifiers: [
  //             {
  //               name: "offset",
  //               options: { offset: [0, -12] },
  //             },
  //           ],
  //         },
  //       }}
  //       {...props} // permite sobrescrever caso necessário
  //     >
  //       {props.children}
  //     </Tooltip>
  //   );
  // }

  function formatTime(time: string | null): string | null {
    if (time === null) {
      return null;
    }
    const regex = /^(\d{1,2}):(\d{2}):(\d{2})$/;
    const match = time.match(regex);
    if (match) {
      const [, hours, minutes, seconds] = match;
      const formattedHours = hours.padStart(2, "0");

      return `${formattedHours}:${minutes}:${seconds}`;
    }
    return null;
  }

  const [show7dias, setShow7dias] = useState(false);

  return (
    <Card
      hospital={hospital}
      style={{ position: "relative", height: isSmallScreen ? 315 : 300 }}
    >
      <h2 style={{ textAlign: "center" }}>
        {item ?? hospital}
        <span style={{ fontSize: "1rem", position: "relative", top: "-1px" }}>
          {" "}
          ({item ? hospital : selectedEspecialidades})
        </span>
      </h2>
      <Tooltip
        title="Últimos 7 dias - Tempo Médio de Espera"
        arrow
        style={{
          position: "absolute",
          top: "1rem",
          right: "1rem",
        }}
      >
        <IconBox hospital={hospital}>
          {show7dias ? (
            <UndoIcon
              onClick={() => setShow7dias((prev) => !prev)}
              style={{
                // color: "#999",
                cursor: "pointer",
              }}
            />
          ) : (
            <InfoIcon
              onClick={() => setShow7dias((prev) => !prev)}
              style={{
                // color: "#999",
                cursor: "pointer",
              }}
            />
          )}
        </IconBox>
      </Tooltip>
      {!show7dias ? (
        <>
          <PLineHeigth4 hospital={hospital}>agora</PLineHeigth4>
          <InfoBox>
            <FlexBox
              gap="0.8rem"
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <p>{strings.hospital.total_aguardando}</p>
              <p style={{ fontSize: "1.2rem" }}>
                <b>
                  {getMetricas(
                    hospital,
                    "pacientes_aguardando_atendimento",
                    item
                  ) | 0}
                </b>
              </p>
              <IoIosPeople size="25px" />

              <Button
                variant="contained"
                size="small"
                endIcon={<ManageSearchIcon />}
                // color="warning"
                style={{
                  backgroundColor: "#C8A2C8",
                  marginLeft: 10,
                  paddingTop: 7,
                  height: 25,
                  position: "relative",
                  top: "-3px",
                  fontSize: "0.7rem",
                  lineHeight: "0.7rem",
                }}
                onClick={() =>
                  openModal(hospital, item || selectedEspecialidades)
                }
              >
                Lista de espera
              </Button>
            </FlexBox>
            <div
              style={{
                // border: "solid 1px #ddd",
                backgroundColor: "white",
                borderRadius: "10px",
                padding: 5,
                marginTop: 5,
              }}
            >
              <FlexBox gap="8px" style={{ marginTop: 5 }}>
                {riscoColorMap.map(({ color, risco, fontColor }) => (
                  <Tooltip
                    key={risco}
                    title={risco}
                    arrow
                    slotProps={slotProps(color, fontColor)}
                  >
                    <CardInfo
                      key={risco}
                      color={color}
                      border={false}
                      // style={{
                      //   backgroundColor: color + "18",
                      //   padding: "5px 0",
                      //   border: "1px solid " + color,
                      // }}
                    >
                      <FlexBox
                        direction="column"
                        align="center"
                        justify="center"
                      >
                        <IoIosPeople size="25px" />
                        <span>
                          {risco === "vermelho"
                            ? 0
                            : getMetricasRisco(
                                risco,
                                hospital,
                                "risco",
                                item,
                                metricasEspecialidades
                              ) || 0}
                        </span>
                      </FlexBox>
                    </CardInfo>
                  </Tooltip>
                ))}
              </FlexBox>
            </div>
          </InfoBox>
          <PLineHeigth4 hospital={hospital}>últimas 24h</PLineHeigth4>
          <InfoBox>
            {/* <FlexBox gap="3rem" style={{ marginTop: "5px" }}>
              <FlexBox
                gap="1rem"
                style={{ justifyContent: "right", alignItems: "center" }}
              >
                <p style={{ whiteSpace: "nowrap" }}>{strings.gaes}</p>
                <FlexBox
                  gap="5px"
                  style={{ alignItems: "center", width: "fit-content" }}
                >
                  <p style={{ fontSize: "1rem" }}>
                    <b>{getMetricas(hospital, "gae_abertas", item) | 0}</b>
                  </p>
                  <IoIosPeople size="25px" />
                </FlexBox>
              </FlexBox>
              <FlexBox
                gap="1rem"
                style={{ justifyContent: "left", alignItems: "center" }}
              >
                <p style={{ whiteSpace: "nowrap" }}>{strings.desistentes}</p>
                <FlexBox
                  gap="5px"
                  style={{ alignItems: "center", width: "fit-content" }}
                >
                  <p style={{ fontSize: "1rem" }}>
                    <b>
                      {getMetricas(hospital, "pacientes_desistentes", item) | 0}
                    </b>
                  </p>
                  <IoIosPeople size="25px" />
                </FlexBox>
              </FlexBox>
            </FlexBox> */}
            <div
              style={{
                // border: "solid 1px #ddd",
                backgroundColor: "white",
                borderRadius: "10px",
                padding: 5,
                marginTop: 5,
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                <b>{strings.especialidade.tempoMedio}</b>
              </p>
              <FlexBox gap="8px">
                {riscoColorMap.map(({ color, risco, fontColor }) => (
                  <Tooltip
                    key={risco}
                    title={risco}
                    arrow
                    slotProps={slotProps(color, fontColor)}
                  >
                    <CardInfo
                      key={risco}
                      color={color}
                      border={false}
                      // style={{
                      //   backgroundColor: color + "18",
                      //   padding: "5px 0",
                      //   border: "1px solid " + color,
                      // }}
                    >
                      <FlexBox
                        direction="column"
                        align="center"
                        justify="center"
                      >
                        <FaClock size="20px" />
                        <span>
                          {risco === "vermelho"
                            ? "IMEDIATO"
                            : formatTime(
                                getMetricasRisco(
                                  risco,
                                  hospital,
                                  "tempo_atendimento",
                                  item,
                                  tempoMedio24horas
                                )
                              ) || "-"}
                        </span>
                      </FlexBox>
                    </CardInfo>
                  </Tooltip>
                ))}
              </FlexBox>
            </div>
          </InfoBox>
        </>
      ) : (
        <>
          <PLineHeigth4 hospital={hospital}>últimos 7 dias</PLineHeigth4>
          <InfoBox>
            <FlexBox
              // gap="1rem"
              direction="column"
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <p>
                <b>{strings.especialidade.tempoMedio}</b>
              </p>
              <p style={{ fontSize: "1.2rem" }}>
                <b>{tempoMedioEspera}</b>
                <FaClock
                  size="20px"
                  color="#666"
                  style={{ position: "relative", top: "3px", left: "5px" }}
                />
              </p>
            </FlexBox>
            <div
              style={{
                // border: "solid 1px #ddd",
                backgroundColor: "white",
                borderRadius: "10px",
                padding: 5,
                marginTop: "1rem",
              }}
            >
              <FlexBox gap="8px">
                {riscoColorMap.map(({ color, risco, fontColor }) => (
                  <Tooltip
                    key={risco}
                    title={risco}
                    arrow
                    slotProps={slotProps(color, fontColor)}
                  >
                    <CardInfo
                      key={risco}
                      color={color}
                      border={false}
                      // style={{
                      //   backgroundColor: color + "18",
                      //   padding: "5px 0",
                      //   border: "1px solid " + color,
                      // }}
                    >
                      <FlexBox
                        direction="column"
                        align="center"
                        justify="center"
                      >
                        <FaClock size="20px" />
                        <span>
                          {risco === "vermelho"
                            ? "IMEDIATO"
                            : formatTime(
                                getMetricasRisco(
                                  risco,
                                  hospital,
                                  "tempo_atendimento",
                                  item,
                                  tempoMedio7dias
                                )
                              ) || "-"}
                        </span>
                      </FlexBox>
                    </CardInfo>
                  </Tooltip>
                ))}
              </FlexBox>
            </div>
          </InfoBox>
        </>
      )}
    </Card>
  );
};

export default Quadro;
